import React from 'react';
import { useTranslation } from 'react-i18next';
import './ComingSoonBadge.css';

export interface ComingSoonBadgeProps {
  /** Custom className */
  className?: string;
}

/**
 * ComingSoonBadge
 *
 * Magenta "EM BREVE" pill used next to the title of a product section that is
 * announced but not yet available. Figma node `1601:14104`.
 *
 * @example
 * ```tsx
 * <ProductSectionCard title={t('idwall Platform')} badge={<ComingSoonBadge />} />
 * ```
 *
 * @since 1.0.0
 * @category Atoms
 */
export const ComingSoonBadge: React.FC<ComingSoonBadgeProps> = ({
  className = '',
}) => {
  const { t } = useTranslation();

  return (
    <span className={`coming-soon-badge ${className}`.trim()}>
      {t('Coming soon')}
    </span>
  );
};

export default ComingSoonBadge;
